'use client'

import { useTranslation } from '../_providers/TranslationProvider.client'

export function useColorGroupLabel() {
  const { pages } = useTranslation()
  const { colorGroupLabels } = pages.product

  const labelMap: Record<string, string> = {
    'core': colorGroupLabels.core,
    'limited edition': colorGroupLabels.limitedEdition,
    'exclusive sample sale': colorGroupLabels.sampleSale,
    'sample sale': colorGroupLabels.sampleSale,
    'exclusive offer': colorGroupLabels.exclusiveOffer,
  }

  return (id: string): string => labelMap[id.toLowerCase()] ?? id
}
